module.exports = __webpack_public_path__ + "img/1590670330.6092fbf9.jpg";